module.exports = __webpack_public_path__ + "92ee5487f9139dc1d78cc320c86928bd.png";